import React from 'react'

const TipsEndShift = ({ row }) => {
  return <div>{row.actualTips?.toLocaleString()}</div>;
};

export default TipsEndShift